"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Url_1 = require("./Url");
var BaseApiService_1 = require("../apiServices/baseApiService/BaseApiService");
var Instance = /** @class */ (function () {
    function Instance() {
    }
    Instance.prototype.monitorMultilpleInstances = function (instances) {
        var url = Url_1.url.ConfigureMultipleInstances.toString();
        return BaseApiService_1.BaseApiService.post(url, instances);
    };
    Instance.prototype.updateExistingInstances = function (instances) {
        var url = Url_1.url.UpdateExistingInstancesUrl.toString();
        return BaseApiService_1.BaseApiService.post(url, instances);
    };
    Instance.prototype.monitorExistingInstance = function (instance) {
        var url = Url_1.url.MonitorExistingInstanceUrl.toString();
        return BaseApiService_1.BaseApiService.post(url, instance);
    };
    Instance.prototype.stopMonitoringMultipleInstances = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = Url_1.url.StopMonitoringInstances;
                return [2 /*return*/, BaseApiService_1.BaseApiService.post(url, data)];
            });
        });
    };
    Instance.prototype.disableSingleOrMultipleMonitoringInstances = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = Url_1.url.DisableMonitoringInstances;
                return [2 /*return*/, BaseApiService_1.BaseApiService.post(url, data)];
            });
        });
    };
    Instance.prototype.enableSingleOrMultipleMonitoringInstances = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = Url_1.url.EnableMonitoringInstances;
                return [2 /*return*/, BaseApiService_1.BaseApiService.post(url, data)];
            });
        });
    };
    Instance.prototype.updateRelatedInstances = function (typeInfo, typeOnly) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = Url_1.url.UpdateRelatedInstances + "?typeOnly=" + typeOnly;
                return [2 /*return*/, BaseApiService_1.BaseApiService.post(url, typeInfo)];
            });
        });
    };
    Instance.prototype.getObjectVariables = function (objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = "" + Url_1.url.ObjectVariables + objectId;
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Instance.prototype.getSCECleanupInstances = function (edgeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = Url_1.url.GetSCECleanupInstances + "/" + edgeId;
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    return Instance;
}());
exports.Instance = Instance;
//# sourceMappingURL=Instance.js.map